var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInicio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "35px",
    viewBox: "0 0 33 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "in\xEDcio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Mobile_Home_Escuro",
    transform: "translate(-59.000000, -15887.000000)",
    fillRule: "nonzero",
    stroke: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 15767.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-77",
    transform: "translate(15.500000, 102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "in\\xEDcio",
    transform: "translate(45.519922, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,31.3879101 L0.0799987793,11.9940881 C0.0799987793,11.0106964 0.543999529,10.0757548 1.31199951,9.4631501 L12.5119995,0.677089418 C13.6639996,-0.225696441 15.279998,-0.225696441 16.447998,0.677089418 L27.6480042,9.44701318 C28.4320042,10.0596179 28.8799988,10.9945752 28.8799988,11.9940881 L28.8799988,31.3879101",
    id: "Vector",
    strokeWidth: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5600781,19.1030592 C10.9664782,19.1030592 9.68007812,20.6152256 9.68007812,22.4885062 L9.68007812,30.3878824 L19.2800781,30.3878824 L19.2800781,22.4885062 C19.2800781,20.6152256 17.9936781,19.1030592 16.4000781,19.1030592 L12.5600781,19.1030592 Z",
    id: "Vector",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 30.9733091,
    x2: 28.8799988,
    y2: 30.9733091,
    id: "Path-6",
    strokeWidth: 2.64,
    strokeLinecap: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicio);
export default __webpack_public_path__ + "static/media/inicio.d44c7e3683245ba9bb750c8fe906a013.svg";
export { ForwardRef as ReactComponent };